import { FundLiterature } from 'model/KidsHub';

export type RowComponentProps = {
  row: FundLiterature;
  selectedShareClass: number;
  onShareClassChange: (row: FundLiterature, shareClass: number) => void;
  onTogglePastPerformance: (row: FundLiterature) => void;
  onTogglePredictivePerformance: (row: FundLiterature) => void;
};

export type KidsTableProps = {
  rows: FundLiterature[];
  isLoading: boolean;
  selectedShareClasses: Record<string, number>;
  onShareClassChange: (row: FundLiterature, shareClass: number) => void;
  onTogglePastPerformance: (row: FundLiterature) => void;
  onTogglePredictivePerformance: (row: FundLiterature) => void;
  className?: string;
};
